import { render, staticRenderFns } from "./live-timer.vue?vue&type=template&id=acce81e8&scoped=true&"
import script from "./live-timer.vue?vue&type=script&lang=ts&"
export * from "./live-timer.vue?vue&type=script&lang=ts&"
import style0 from "./live-timer.vue?vue&type=style&index=0&id=acce81e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acce81e8",
  null
  
)

export default component.exports